import Polyglot from 'node-polyglot';
import locale_de from './locales/de.json';
import locale_en from './locales/en.json';
import locale_es_es from './locales/es-es.json';
import locale_es_mx from './locales/es-mx.json';
import locale_fr from './locales/fr.json';
import locale_it from './locales/it.json';
import locale_ja from './locales/ja.json';
import locale_nl from './locales/nl.json';

const safeNavigator: any = typeof navigator !== 'undefined' ? navigator : undefined;

const languageString =
    safeNavigator?.userLanguage ||
    safeNavigator?.language ||
    safeNavigator?.browserLanguage ||
    safeNavigator?.systemLanguage
    || '';

const defaultLanguageString = 'en';

const localeArr = languageString.toLowerCase().split(/[_-]/);
const language = localeArr[0];
const country = localeArr[1];

const polyglot = new Polyglot();

polyglot.extend(locale_de, 'de');
polyglot.extend(locale_en, 'en');
polyglot.extend(locale_es_mx, 'es');
polyglot.extend(locale_es_es, 'es_es');
polyglot.extend(locale_es_mx, 'es_mx');
polyglot.extend(locale_fr, 'fr');
polyglot.extend(locale_it, 'it');
polyglot.extend(locale_ja, 'ja');
polyglot.extend(locale_nl, 'nl');

export const translated = (phrase: string, options?: number | Polyglot.InterpolationOptions): string => {
    // try language and country phrase
    if (language && country) {
        const languageCountryPhrase = `${language}_${country}.${phrase}`;
        if (polyglot.has(languageCountryPhrase)) {
            return polyglot.t(languageCountryPhrase, options);
        }
    }

    // fall back to language only
    if (language) {
        const languagePhrase = `${language}.${phrase}`;
        if (polyglot.has(languagePhrase)) {
            return polyglot.t(languagePhrase, options);
        }
    }

    // fall back to default
    const defaultPhrase = `${defaultLanguageString}.${phrase}`;
    if (polyglot.has(defaultPhrase)) {
        return polyglot.t(defaultPhrase, options);
    }

    // fall back to phrase itself
    return phrase;
};